import React from "react";
import styled from "styled-components";
import * as Icon from "react-feather";

import { H1, P } from "../../atoms/Texts";
import { useNavigate } from "react-router";

const PageHeroStyle = styled.div`
  background: #f8f6fe;
`;

const PageHero = ({ title, description, className, back, goBackText }) => {
  const navigate = useNavigate();

  return (
    <PageHeroStyle className={`pt-16 pb-12 container ${className ? className : ""}`}>
      <H1 fontSize="26px" color="#22202D" className="mb-4">
        {title}
      </H1>
      {description && <P color="#1E202A">{description}</P>}
      {back && (
        <button
          className="flex items-center cursor-pointer"
          style={{
            width: "fit-content",
          }}
          onClick={() => navigate(-1)}
        >
          <Icon.ChevronLeft size={14} color="#7D7B96" className="mr-2" />

          <P color="#1E202A" fontSize="14px" smallSize="14px">
            {goBackText}
          </P>
        </button>
      )}
    </PageHeroStyle>
  );
};

export default PageHero;
